import * as React from "react";
type Props = {
  className?: string,
};
function SvgPork({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Pork"
      className={className}
    >
      <path
        d="M30.5151 16.5662C30.6769 15.7945 30.7304 15.4029 30.7935 14.8146C30.8566 14.227 30.8808 13.7295 30.8873 13.3205C30.8841 13.0917 30.8574 12.8007 30.8808 12.5209C30.9043 12.2418 30.9763 11.974 31.1712 11.7906C31.5327 11.4454 31.9767 11.3274 32.3714 11.5227C32.7653 11.7188 33.1098 12.2259 33.2691 13.13C33.4042 13.417 33.7868 13.3468 34.2186 13.2822C34.6505 13.2161 35.1309 13.1571 35.4593 13.4688C35.7327 13.7263 35.8394 13.8682 35.8774 14.0564C35.9163 14.2453 35.8855 14.4789 35.8831 14.9238C35.9114 15.037 35.9551 15.1749 36.0343 15.3121C36.1144 15.4492 36.2301 15.5871 36.404 15.6979C36.6919 15.8183 36.8464 15.7521 37.0801 15.7107C37.3146 15.6708 37.6284 15.6549 38.2366 15.8765C38.6006 16.1571 38.6548 16.6259 38.4623 17.0501C38.2698 17.4742 37.8298 17.8545 37.2046 17.9573C36.5997 18.0753 35.7828 18.2451 34.8406 18.4269C33.8984 18.6079 32.9129 18.7596 31.8049 18.9286M29.4567 15.9381C32.6519 17.361 32.2285 20.4705 30.4061 22.9526C28.4985 25.5487 25.3649 26.9635 22.3948 27.7966C16.3133 29.5027 8.32641 28.4947 3.68802 23.7402C1.9976 22.0073 0.37511 19.2029 2.30251 17.0234C4.38157 14.6697 8.0294 15.611 10.4955 16.5206C13.5256 17.6384 16.3393 18.9068 19.6277 18.1681C22.7147 17.4757 26.1951 14.4851 29.4567 15.9381Z"
        stroke="currentColor"
        strokeWidth={0.945455}
      />
    </svg>
  );
}
export default SvgPork;
